<template>
    <div class="topfixed">
        <div
            class="fr-ac-jsb"
            style="margin: 0 auto; height: 60px; width: 1200px"
        >
            <div class="fr-ac" @click="toProvince">
                <img
                    v-if="logo"
                    :src="LOGO"
                    alt=""
                    class="mr-35"
                    style="width: 110px"
                />
                <img :src="ICON" alt="" style="width: 21px; height: 25px" />
                <div class="px-15 fr-ac">
                    <div class="fs-15">{{ province }}</div>
                    <i class="el-icon-caret-bottom"></i>
                </div>
            </div>
            <div class="fr-ac">
                <div class="py-5 px-20 fr-ac radius-15" 
                    style="border:1px solid #ccc;color: #ccc;"
                    @click="searchClick"
                    v-if="search"
                >
                    <p>请输入关键字搜索</p>
                    <i class="el-icon-search pl-20"></i>
                </div>
                <div class="fr-ac mt-4">
                    <div
                        v-for="(item, ind) in fixedList"
                        :key="ind"
                        class="ml-20 mr-20 fs-15"
                        :class="
                            fixedIndex == ind ? 'fixedItemActive' : 'fixedItem'
                        "
                        @click="fixedClick(item, ind)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <el-popover
                    placement="bottom"
                    width="200"
                    trigger="click"
                    v-if="is_userInfo"
                >
                    <div class="pointer mb-10">身份信息</div>
                    <div class="pointer" @click="exit">退出</div>

                    <div slot="reference" class="fr-ac">
                        <img class="logo" :src="userInfo.head_image" />
                        <div class="ml-5">{{ userInfo.phone }}</div>
                    </div>
                </el-popover>
                <div class="ml-10 rightLogin" v-else @click="LOGIN">
                    登录/注册
                </div>
            </div>
        </div>

        <DialogView :value="showDialog" :width="45">
            <template #dialogMain>
                <p class="pb-20 fs-18 bold t-c">请选择你所在的高考省份</p>
                <div class="listBox">
                    <div
                        v-for="(item, ind) in provinceList"
                        :key="ind"
                        class="provinceItem fc-ac-jc"
                    >
                        <div
                            class="provinceBorder fc-ac-jc pointer"
                            :class="
                                provinceActive == item.province
                                    ? 'provinceBG'
                                    : ''
                            "
                            style="font-size: 15px"
                            @click.stop="provinceClick(item, ind)"
                        >
                            {{ item.province }}
                        </div>
                    </div>
                </div>
            </template>
            <template #dialogFoot>
                <div class="fr-ac-jc">
                    <div
                        class="provinceConfirm px-100 py-8"
                        @click.stop="provinceConfirm"
                    >
                        确定
                    </div>
                </div>
            </template>
        </DialogView>
        <DialogView :value="showTips" width="30">
            <template #dialogMain>
                <div class="fr-ac-jsb">
                    <p class="fs-16">温馨提示</p>
                    <p class="fs-24" @click.stop="showTips = false">×</p>
                </div>
                <div class="t-c pt-30 pb-10">{{ showTipsContent }}</div>
            </template>
            <template #dialogFoot>
                <div class="fr-ac-jc">
                    <div
                        class="provinceConfirm px-50 py-8"
                        @click.stop="showTips = false"
                    >
                        {{ showTipsButton }}
                    </div>
                </div>
            </template>
        </DialogView>
    </div>
</template>
<script>
import { getCookie, setCookie } from "@/utils/common";
import { homepage_index } from "@/utils/api";
import { Message } from "element-ui";

export default {
    name: "HeadView",
    props: {
        logo: {
            type: Boolean,
            default: true,
        },
        province: {
            type: String,
            default: "福建",
        },
        active: {
            type: Number,
            default: 0,
        },
        isShow: {
            type: Boolean,
            default: false,
        },
        search: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        provinceList() {
            return this.$store.state.page_one.list_province || [];
        },
    },
    watch: {},
    data(props) {
        return {
            LOGO: `${process.env.VUE_APP_IMG_URL}/www/gkzzd/uploads/20251014/4dda0690f8d7775f4be737b55b9a2346.png`,
            ICON: `${process.env.VUE_APP_IMG_URL}/www/gkzzd/uploads/20241018/67915fb0317632bf5decf4a0b302e4ce.png`,
            fixedList: [
                {
                    id: 1,
                    name: "首页",
                    path: "/",
                    is_open: true,
                    is_vip: true,
                    business: "",
                },
                {
                    id: 2,
                    name: "查大学",
                    path: "/fill/fill_school",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 3,
                    name: "查专业",
                    path: "/fill/fill_speciality",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 4,
                    name: "查试卷",
                    path: "/fill/fill_paper",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 5,
                    name: "选科系统",
                    path: "/fill/fill_optional",
                    is_open: false,
                    is_vip: true,
                    business: "选科系统",
                },
                {
                    id: 6,
                    name: "模拟填报",
                    path: "/fill/fill_index",
                    is_open: false,
                    is_vip: false,
                    business: "模拟填报",
                },
            ],
            fixedIndex: props.active || 0,
            is_userInfo: false,
            userInfo: {},
            // SSR 阶段不读 cookie,统一初始化 false,避免 hydration 不一致
            // 真正是否弹窗在 mounted(客户端)里判断
            showDialog: false,
            provinceActive: "",
            provinceId: "",
            showTips: false,
            showTipsContent: "",
            showTipsButton: "",
        };
    },
    methods: {
        exit() {
            localStorage.clear(); //清除本地缓存
            document.cookie = `${"province"}=; Max-Age=0; path=/; domain=.gkzzd.cn`;
            document.cookie = `${"province_id"}=; Max-Age=0; path=/; domain=.gkzzd.cn`;
            location.reload();
        },
        searchClick(){
            window.location.replace(`${process.env.VUE_APP_OUT_URL}/fill/fill_search`);
        },
        fixedClick(val, ind) {
            if (val.is_open) {
                if (val.is_vip) {
                    this.fixedIndex = ind;
                    window.location.replace(
                        `${process.env.VUE_APP_OUT_URL}${val.path}`
                    );
                } else {
                    if (this.$store.state.user.token) {
                        this.showTips = true;
                        this.showTipsContent = `您暂未开通【${val.business}】功能，开通系统即可体验`;
                        this.showTipsButton = "开通";
                    } else {
                        window.location.replace(
                            `${process.env.VUE_APP_OUT_URL}${this.$route.path}?openLogin=true`
                        );
                        // Message({
                        //     message: "接口签名失败",
                        //     type: "info",
                        // });
                    }
                }
            } else {
                this.showTips = true;
                this.showTipsContent = `当前省份未开放【${val.business}】功能，敬请期待！`;
                this.showTipsButton = "确定";
            }
        },
        toProvince() {
            if (this.$store.state.user.token) {
                if (this.$store.state.user.info.isWhite) {
                    this.showDialog = true;
                }
            } else {
                this.showDialog = true;
            }
        },
        provinceClick(val, ind) {
            this.provinceActive = val.province;
            this.provinceId = val.id;
        },
        async provinceConfirm() {
            if (this.provinceActive == "") {
                return;
            }
            setCookie("province", this.provinceActive, 1);
            setCookie("province_id", this.provinceId, 1);
            await this.getIndex(this.provinceActive);
            this.$emit("closeProvince", this.provinceActive, this.provinceId);
            this.showDialog = false;
        },
        async getIndex(province) {
            const res = await homepage_index({
                sf: province,
            });
            if (res.status == 200) {
                const { moni, wucha, xuanke } = res.data;
                this.$store.dispatch("user/setHomePage", res.data);
                this.fixedList[1].is_open = wucha.is_open;
                this.fixedList[1].is_vip = wucha.is_vip;
                this.fixedList[2].is_open = wucha.is_open;
                this.fixedList[2].is_vip = wucha.is_vip;
                this.fixedList[3].is_open = wucha.is_open;
                this.fixedList[3].is_vip = wucha.is_vip;
                this.fixedList[4].is_open = xuanke.is_open;
                this.fixedList[5].is_open = moni.is_open;
                this.fixedList[5].is_vip = moni.is_vip;
            }
        },
        LOGIN() {
            let query = new URLSearchParams({
                ...this.$route.query,
                openLogin: true,
            });
            window.location.replace(`${process.env.VUE_APP_OUT_URL}${this.$route.path}?` + query.toString());
        },
    },
    mounted() {
        // 仅客户端读 cookie,SSR 阶段 data() 已统一初始化 false
        // 这样避免 SSR/客户端 cookie 不一致导致的 hydration mismatch
        const province = getCookie("province");
        if (province) {
            this.provinceActive = province;
            this.getIndex(province);
        } else {
            // 没选过省份才弹窗
            this.showDialog = true;
        }
    },
    created() {},
};
</script>
<style lang="scss" scoped>
.topfixed {
    width: 100%;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 99;
    .fixedItemActive {
        color: #3c78ff;
        border-bottom: 4px solid #3c78ff;
        cursor: pointer;
    }
    .fixedItem {
        border-bottom: 4px solid #fff;
        cursor: pointer;
        &:hover {
            color: #3c78ff;
        }
    }
    .rightLogin {
        padding: 8px 15px;
        border-radius: 20px;
        border: 1px solid #3c78ff;
        cursor: pointer;
        &:hover {
            color: #3c78ff;
        }
    }
    .listBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        grid-template-rows: 4;
        grid-template-columns: 9;
    }
    .provinceItem {
        margin-bottom: 15px;
        width: calc(100% / 9);

        .provinceBorder {
            width: 60%;
            padding: 5px 0;
            border: 1px solid #eee;
            border-radius: 5px;
        }
        .provinceBG {
            background: #3c78ff;
            color: #fff;
            border: 1px solid #3c78ff;
        }
    }
    .provinceConfirm {
        background: #3c78ff;
        color: #fff;
        margin: 30px 0 0 0;
        border-radius: 15px;
    }
}
</style>